import { BqResponse } from '~/api/def/endpoints/types';
import { getExecEndpoint } from '~/api/service/getExecEndpoint';
import { documentEndpoint } from '~/api/def/endpoints/document/documentEndpoint';

/**
 * @tags document
 * @name DocumentGDriveGET
 * @summary Get documents shared by g-drive.
 * @param payload Email of the owner of shared folder.
 * @request POST:/document/shared-g-drive
 * */
export const endpointSharedDocumentGDriveGET = async (
  payload?: GDriveSharedDocumentPayload,
) => {
  return await documentGDriveSharedDocsExec<'GET'>({
    method: 'GET',
    urlExtra: `/shared-g-drive-docs${payload ? `?filterSyncedFolders=${payload.filterSyncedFolders}&fundId=${payload.fundId}${payload.portfolioCompanyId ? `&portfolioCompanyId=${payload.portfolioCompanyId}` : ''}` : ''}`,
  });
};
interface GDriveSharedDocumentEndpointDef {
  endpoint: typeof documentEndpoint;
  methods: {
    GET: {
      response: GDriveSharedDocumentResponse;
      payload: GDriveSharedDocumentPayload;
    };
  };
}

export type GDriveSharedDocumentResponse = BqResponse<{
  data: GDriveSharedDocumentAPIModel[];
}>;

type GDriveSharedDocumentPayload = {
  filterSyncedFolders: boolean;
  fundId: string;
  portfolioCompanyId?: string;
};

const documentGDriveSharedDocsExec =
  getExecEndpoint<GDriveSharedDocumentEndpointDef>(documentEndpoint);

type FileData = {
  id: string;
  name: string;
  mimeType: string;
  parents?: string[];
};

export type GDriveSharedDocumentAPIModel = {
  label: string;
  data: FileData;
  children: GDriveSharedDocumentAPIModel[];
  key: string;
};

/**
 * @tags document
 * @name DocumentGDrivePOST
 * @summary Uploads selected document from google drive and run field extraction for them.
 * @param payload
 * @request POST:/document/shared-g-drive-docs/field-extraction
 * */
export const endpointUploadDocsFromGDriveAndFieldExtractionPOST = async (
  payload: uploadAndRunFieldExtractionPayload,
) => {
  return await documentGDriveUploadDocsAndFieldExtractionExec<'POST'>({
    method: 'POST',
    urlExtra: '/shared-g-drive-docs/field-extraction',
    payload: payload,
  });
};

interface GDriveUploadDocAndFieldExtractionEndpointDef {
  endpoint: typeof documentEndpoint;
  methods: {
    POST: {
      response: GDriveUploadDocAndFieldExtractionResponse;
      payload: uploadAndRunFieldExtractionPayload;
    };
  };
}

export type GDriveUploadDocAndFieldExtractionResponse = BqResponse<{
  data: Record<string, never>;
}>;

const documentGDriveUploadDocsAndFieldExtractionExec =
  getExecEndpoint<GDriveUploadDocAndFieldExtractionEndpointDef>(
    documentEndpoint,
  );

type uploadAndRunFieldExtractionPayload = {
  fundId: string;
  portfolioCompanyId?: string;
  documentIds: string[];
};
